import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@salesforce/design-system-react';

import './AdvancedSettingStep.scss';

export class AdvancedSettingStep extends Component {
  render() {
    const { title, description, rightNav, iconName, iconColor } = this.props;
    return (
      <div className="advanced-setting-step">
        <div className="slds-grid">
          <div className="advanced-setting-step-icon">
            <span>
              <Icon
                containerClassName={iconColor ? `custom-bg-${iconColor}` : ''}
                category="standard"
                name={iconName}
                size="medium"
              />
            </span>
          </div>
          <div className="step-info slds-col">
            <h2>{title}</h2>
            <div className="setup-step-description">{description}</div>
          </div>
          <div className="right-nav slds-col">{rightNav}</div>
        </div>
        <div className="slds-grid">{this.props.children}</div>
      </div>
    );
  }
}

AdvancedSettingStep.propTypes = {
  iconName: PropTypes.string.isRequired,
  iconColor: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  rightNav: PropTypes.node.isRequired
};

export default AdvancedSettingStep;
